import React, { useEffect, useState } from "react";
import { X, Sparkles, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

const DISMISS_KEY = "cwk_sticky_cta_dismissed_v1";

export default function StickyCTABar() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    let dismissed = false;
    try { dismissed = sessionStorage.getItem(DISMISS_KEY) === "1"; } catch {/* */}
    if (!dismissed) {
      // Show after a tiny delay to avoid CLS
      const t = setTimeout(() => setShow(true), 1200);
      return () => clearTimeout(t);
    }
  }, []);

  if (!show) return null;
  return (
    <div className="sticky top-0 z-[55] bg-gradient-to-r from-[#FF0066] via-pink-600 to-amber-500 text-white text-xs md:text-sm shadow-lg" data-testid="sticky-cta-bar">
      <div className="max-w-7xl mx-auto px-3 md:px-6 py-2 flex items-center gap-2 md:gap-3 justify-center flex-wrap">
        <Sparkles className="w-3.5 h-3.5 shrink-0" />
        <span className="font-medium leading-snug">
          🎯 <b>Free Career Guidance Call</b> with Kamlesh Sir · Limited slots today
        </span>
        <Link
          to="/courses"
          className="inline-flex items-center gap-1 bg-white text-[#FF0066] hover:bg-white/90 font-bold rounded-full px-3 py-0.5 text-[11px] md:text-xs shrink-0"
          data-testid="sticky-cta-book-btn"
        >
          Book free call <ArrowRight className="w-3 h-3" />
        </Link>
        <button
          onClick={() => { setShow(false); try { sessionStorage.setItem(DISMISS_KEY, "1"); } catch {/**/} }}
          className="ml-1 p-1 rounded-full hover:bg-white/15 shrink-0"
          aria-label="Dismiss"
          data-testid="sticky-cta-close"
        >
          <X className="w-3.5 h-3.5" />
        </button>
      </div>
    </div>
  );
}
